import React, { useEffect } from "react"
import Glide from "@glidejs/glide"

export default function CarouselLogo() {
  useEffect(() => {
    const slider = new Glide(".glide-09", {
      type: "carousel",
      autoplay: 1,
      animationDuration: 3000,
      animationTimingFunc: "linear",
      perView: 4,
      classes: {
        nav: {
          active: "[&>*]:bg-wuiSlate-700",
        },
      },
      breakpoints: {
        1024: {
          perView: 3,
        },
        640: {
          perView: 2,
          gap: 36,
        },
      },
    }).mount()

    return () => {
      slider.destroy()
    }
  }, [])

  return (
    <>
      {/*<!-- Component: Testimonial carousel --> */}
      <div className="glide-09 relative w-full overflow-hidden bg-white py-8">
        {/* <!-- Slides --> */}
        <div data-glide-el="track">
          <ul className="whitespace-no-wrap flex-no-wrap [backface-visibility: hidden] [transform-style: preserve-3d] [touch-action: pan-Y] [will-change: transform] relative flex w-full overflow-hidden p-0">
            <li>
              <img
                src="assests/icons/hosting/cpanel.svg"
                className="m-auto h-10 max-h-full w-auto max-w-full"
                alt="cpanel"
              />
            </li>
            <li>
              <img
                src="assests/icons/hosting/cloudlinux.svg"
                alt="cloudlinux"
                className="m-auto h-10 max-h-full w-auto max-w-full"
              />
            </li>
            <li>
              <img
                src="assests/icons/hosting/litespeed.svg"
                alt="litespeed"
                className="m-auto h-10 max-h-full w-auto max-w-full"
              />
            </li>
            <li>
              <img
                src="assests/icons/hosting/letsencrypt.svg"
                alt="letsencrypt"
                className="m-auto h-10 max-h-full w-auto max-w-full"
              />
            </li>
            <li>
              <img
                src="assests/icons/hosting/nodejs.svg"
                alt="nodejs"
                className="m-auto h-10 max-h-full w-auto max-w-full"
              />
            </li>
            <li>
              <img
                src="assests/icons/hosting/laravel.svg"
                alt="laravel"
                className="m-auto h-10 max-h-full w-auto max-w-full"
              />
            </li>
            <li>
              <img
                src="assests/icons/hosting/ruby.svg"
                alt="ruby"
                className="m-auto h-10 max-h-full w-auto max-w-full"
              />
            </li>
            <li>
              <img
                src="assests/icons/hosting/python.svg"
                alt="python"
                className="m-auto h-10 max-h-full w-auto max-w-full"
              />
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}